import { Eye, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { COLUMN_CHOICES } from './gridLayout';

/**
 * Панель режима правки раскладки: сохранить, отменить, сбросить к умолчанию, число столбцов и
 * лоток скрытых элементов. «Показать» здесь — та же настройка, что галка в «Интерфейсе», и
 * срабатывает сразу, а не при сохранении раскладки.
 */
const LayoutEditToolbar = ({
  tabTitle,
  columns,
  onColumnsChange,
  onSave,
  onCancel,
  onReset,
  canReset,
  isBusy,
  hidden
}) => (
  <div data-layout-toolbar className="rounded-xl border border-primary/40 bg-primary/5 p-3">
    <div className="flex flex-wrap items-center gap-3">
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">Раскладка вкладки «{tabTitle}»</p>
        <p className="text-xs text-muted-foreground">
          Тяните элемент за ручку, размер меняйте за правый нижний угол или кнопками на рамке.
          Клиенты увидят раскладку после сохранения.
        </p>
      </div>
      <div className="flex items-center gap-2 text-sm">
        <span className="text-muted-foreground">Столбцов</span>
        <Select
          trackId="layout.edit.columns"
          trackValue
          value={String(columns)}
          onValueChange={(value) => onColumnsChange(Number(value))}
          disabled={isBusy}
        >
          <SelectTrigger className="h-8 w-20" aria-label="Число столбцов сетки">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {COLUMN_CHOICES.map((choice) => (
              <SelectItem key={choice} value={String(choice)}>{choice}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        data-ev="layout.edit.reset"
        disabled={!canReset || isBusy}
        title={canReset ? 'Вернуть вкладке раскладку по умолчанию' : 'У вкладки и так раскладка по умолчанию'}
        onClick={onReset}
      >
        Сбросить к умолчанию
      </Button>
      <Button type="button" size="sm" variant="outline" data-ev="layout.edit.cancel" disabled={isBusy} onClick={onCancel}>
        Отмена
      </Button>
      <Button type="button" size="sm" data-ev="layout.edit.save" disabled={isBusy} onClick={onSave}>
        {isBusy && <Loader2 className="animate-spin" />}
        Сохранить
      </Button>
    </div>

    {hidden.length > 0 && (
      <div data-layout-hidden className="mt-3 flex flex-wrap items-center gap-2 border-t border-primary/20 pt-3">
        <span className="text-xs text-muted-foreground">Скрытые элементы:</span>
        {hidden.map((entry) => (
          <Button
            key={entry.id}
            type="button"
            size="sm"
            variant="secondary"
            className="h-7"
            data-ev="layout.hidden.show"
            data-layout-hidden-item={entry.id}
            disabled={isBusy}
            title="Показать на вкладке"
            onClick={entry.show}
          >
            <Eye />
            {entry.title}
          </Button>
        ))}
      </div>
    )}
  </div>
);

export default LayoutEditToolbar;
